import { useState } from "react";
import { video } from "../data/scenes";

export default function VideoViewer() {

  return (
    <div
      style={{
        width: "100%",
        height: "100dvh",
        background: "#000",
        position: "relative",
      }}
    >
    
      <video
        controls
        autoPlay
        playsInline
        style={{
          width: "100%",
          height: "100%",
          objectFit: "contain",
        }}
      >
        <source src={video} type="video/mp4" />
      </video>
    </div>
  );
}